// FallLaunch.js
import React from 'react';
import './News.css';

export default function FallLaunch() {
  return (
    <div className="page-container">
      <h1 className="news-title">Fall Class Launch: New Dates, Kits & Upgrades</h1>
      <p className="news-meta">Published by Mohit Singh, ChronoTech Robotics Team - Monday, August 19, 2025</p>

      <p>
        We're excited to announce the official launch of our <strong>Fall 2025 Robo Kids Learning Program</strong> — with updated kits, new parts, and improved instruction across all four levels.
        Registration is now open for September, and kits begin shipping starting <strong>August 25th</strong>.
      </p>

      <p>
        Every course level now comes with new hardware improvements based on student feedback. Motors are more powerful, wires are color-coded for easy use, and our build guides are even simpler to follow.
        Classes are hosted live on Zoom and include full support, step-by-step builds, and fun challenges for each level.
      </p>

      <h3>Fall 2025 Class Levels</h3>

      <ul>
        <li>
          <strong>Level 1: Robotics Foundations – $400</strong><br />
          Learn basic circuits, motors, and sensors with hands-on activities.
        </li>

        <li>
          <strong>Level 2: Smart Robotics & Coding – $500</strong><br />
          Work with microcontrollers and simple coding tasks to bring robots to life.
        </li>

        <li>
          <strong>Level 3: Autonomous Robotics Mastery – $750</strong><br />
          Master logic, sensors, and autonomous programming for advanced robotics.
        </li>

        <li>
          <strong>Level X: Custom Robotics Innovation Lab – $800</strong><br />
          Build anything with instructor help — spider bots, smart cars, custom sensors, and more.
        </li>
      </ul>

      <h3>Class Schedule</h3>
      
      <div className="info-box">
        <p><strong>All classes are on the same dates:</strong></p>
        <ul>
          <li>Thursday, September 12</li>
          <li>Friday, September 13</li>
          <li>Sunday, September 15</li>
          <li>Tuesday, September 17</li>
        </ul>
      </div>

      <div className="info-box">
        <p>
          <strong>All classes run from 4:00 PM onwards Pacific Time</strong> and include live instruction, Q&A sessions, and personalized project feedback.
        </p>
      </div>

      <p>
        Whether your child is a beginner or an advanced builder, we have a class for them. All kits are shipped directly to your door, and all classes are 100% remote with interactive Zoom sessions.
        If you're unsure which level is best for your child, contact us anytime — we're happy to help you choose!
      </p>

      <p>
        Ready to get started? Visit our registration page or email us at <strong>support@chronotechrobotics.com</strong> for questions about course levels, kit contents, or technical requirements.
      </p>

      <p className="news-signoff">— </p>
    </div>
  );
}